import axios from 'axios';
import moment from 'moment';
import '@/filters';
import users from '@/users';
import enquiriesTools from '@/employee/enquiries/enquiriesTools';

export default {
  name: 'customerStatements',
  components: {
    DataGridComp: require('@/customcontrols/datagrid.vue').default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
    LoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
    MenuListItem: require('@/employee/enquiries/menuListItem.vue').default,
  },
  mixins: [users, enquiriesTools],
  data: function () {
    return {
      settingFor: 'customer',
      isDetLoading: true,
      customerAllData: null,
      menuVisible: true,
      customerName: '',
      lang: '',

      selectedStatementId: -1,

      statements: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "statementNoAbs",
        isLoading: true,
      },
      statmTransactions: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "transNoAbs",
        isLoading: false,
      },
      unbilledTransactions: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "transNoAbs",
        isLoading: false,
      },
      transactions: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "transNoAbs",
        isLoading: false,
      },

      isTransactionsLoading: true,
      lastInvoiveIssueDate: '',
      lastInvoiveIssueAmount: '',
      lastReadingDate: '',
      lastReading: '',

      subCons: {},

      propId: null,
      custkey: null,

      pagesLoaded: ['Transactions', 'UnbilledTransactions','Statements'],
    }
  },
  mounted() {
    this.goToDefaultTab(this.selectedTab);
  },
  computed: {
    connTableData: function () {
      if (!this.connections)
        return;

      let data = this.connections.filter(a => a.title != 'connId' && a.title != 'mainConnId' && a.title != 'meterId');

      let arr = [], indx = 1, i = 1;

      for (i; i < data.length; i++) {
        if (data[i].title == 'connNo') {
          arr.push({ data: data.slice(i - indx, i), id: arr.length });
          indx = 1;
        }
        else
          indx++;
      }

      arr.push({ data: data.slice(i - indx, i), id: arr.length });

      //console.log("connTableData", arr);
      return arr;
    },
    isLoading: function () {
      return this.statements.isLoading && this.unbilledTransactions.isLoading && this.transactions.isLoading;
    },
    showEmptyState: function () {
      if (
        ((!this.unbilledTransactions.data || this.unbilledTransactions.data.length == 0) && this.selectedTab == 'UnbilledTransactions') ||
        ((!this.transactions.data || this.transactions.data.length == 0) && this.selectedTab == 'Transactions') ||
        ((!this.statements.data || this.statements.data.length == 0) && this.selectedTab == 'Statements')
      )
        return true;
      else
        return false;
    },
  },
  watch: {
    selectedTab: function (val) {
      switch (val) {
        default:
          this.$root.$emit(`refresh_data_grid:${val}DataGrid`);
          break;
      }

      this.changeUrlLink(val);
    }
  },
  methods: {
    init() {
      this.propId = this.$route.params.propertyId;
      this.custkey = this.$route.params.custkey;
      this.tabs.Statements.show = true;

      this.selectedTab = 'Statements';
      this.isStatementsExpanded = true;

      this.fillColumns();
      this.getData();
    },
    fillColumns() {
      this.unbilledTransactions.cols.length = 0;
      this.statmTransactions.cols.length = 0;
      this.statements.cols.length = 0;

       //=========
      //statements
      this.statements.cols.push({ dataField: 'account', caption: this.$t('enquiriesAccount.custkey') });
      this.statements.cols.push({ dataField: 'customerName', caption: this.$t('enquiriesAccount.accountName') });
      this.statements.cols.push({ dataField: 'statementDate', caption: this.$t('enquiriesAccount.BillingDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.statements.cols.push({ dataField: 'statementNoAbs', caption: this.$t('enquiriesAccount.statementNo') });
      this.statements.cols.push({ dataField: 'paymentNo', caption: this.$t('enquiriesAccount.invoiceNo') });
      this.statements.cols.push({ dataField: 'balance', caption: this.$t('enquiriesAccount.balance') });
      this.statements.cols.push({ dataField: 'payBy', caption: this.$t('enquiriesAccount.payBy'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.statements.cols.push({ dataField: 'emailSent', caption: this.$t('enquiriesAccount.emailSent'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });
      this.statements.cols.push({ dataField: 'smsSent', caption: this.$t('enquiriesAccount.smsSent'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });
      this.statements.cols.push({ dataField: 'paymentMethodName', caption: this.$t('enquiriesAccount.paymentMethod') });

      //=====================
      //unbilled transactions
      this.unbilledTransactions.cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });
      this.unbilledTransactions.cols.push({ dataField: 'accountName', caption: this.$t('enquiriesAccount.accountName') });
      this.unbilledTransactions.cols.push({ dataField: 'effectiveDate', caption: this.$t('enquiriesAccount.date'), dataType: 'date' });
      this.unbilledTransactions.cols.push({ dataField: 'transNoAbs', caption: this.$t('enquiriesAccount.transNo') });
      this.unbilledTransactions.cols.push({ dataField: 'transactionType', caption: this.$t('enquiriesAccount.type') });
      this.unbilledTransactions.cols.push({ dataField: 'transactionDescription', caption: this.$t('enquiriesAccount.description') });
      this.unbilledTransactions.cols.push({ dataField: 'documentNo', caption: this.$t('enquiriesAccount.documentNo') });
      this.unbilledTransactions.cols.push({ dataField: 'currentReading', caption: this.$t('enquiriesAccount.reading') });
      this.unbilledTransactions.cols.push({ dataField: 'consumption', caption: this.$t('enquiriesAccount.consumption') });
      this.unbilledTransactions.cols.push({ dataField: 'debit', caption: this.$t('enquiriesAccount.debit') });
      this.unbilledTransactions.cols.push({ dataField: 'credit', caption: this.$t('enquiriesAccount.credit') });
      this.unbilledTransactions.cols.push({ dataField: 'vatAmountS', caption: this.$t('enquiriesAccount.vat') });
      this.unbilledTransactions.cols.push({ dataField: 'balanceS', caption: this.$t('enquiriesAccount.balance') });
      this.unbilledTransactions.cols.push({ dataField: 'statementNoAbs', caption: this.$t('enquiriesAccount.statementNo') });
      this.unbilledTransactions.cols.push({ dataField: 'billingDate', caption: this.$t('enquiriesAccount.statementDate'), dataType: 'date' });
      this.unbilledTransactions.cols.push({ dataField: 'propertyRef', caption: this.$t('enquiriesAccount.propertyRef') });
      this.unbilledTransactions.cols.push({ dataField: 'meterRef', caption: this.$t('enquiriesAccount.meterRef') });
      this.unbilledTransactions.cols.push({ dataField: 'glBatchNo', caption: this.$t('enquiriesAccount.batchNo') });
      this.unbilledTransactions.cols.push({ dataField: 'consumptionTypeS', caption: this.$t('enquiriesAccount.consumptionType') });
      this.unbilledTransactions.cols.push({ dataField: 'revTransNoAbs', caption: this.$t('enquiriesAccount.revTransNo') });
      this.unbilledTransactions.cols.push({ dataField: 'stampUser', caption: this.$t('enquiriesAccount.stampUser') });
      this.unbilledTransactions.cols.push({ dataField: 'stampDate', caption: this.$t('enquiriesAccount.stampDate'), dataType: 'date' });
      //this.unbilledTransactions.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });

      //=================
      //statmTransactions
      this.statmTransactions.cols.push({ dataField: 'transNoAbs', caption: this.$t('enquiriesCustomerDetails.transNo') });
      this.statmTransactions.cols.push({ dataField: 'transactionType', caption: this.$t('enquiriesCustomerDetails.type') });
      this.statmTransactions.cols.push({ dataField: 'effectiveDate', caption: this.$t('enquiriesCustomerDetails.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.statmTransactions.cols.push({ dataField: 'transactionDescription', caption: this.$t('enquiriesCustomerDetails.description') });
      this.statmTransactions.cols.push({ dataField: 'documentNo', caption: this.$t('enquiriesCustomerDetails.documentRef') });
      this.statmTransactions.cols.push({ dataField: 'debit', caption: this.$t('enquiriesCustomerDetails.debit') });
      this.statmTransactions.cols.push({ dataField: 'credit', caption: this.$t('enquiriesCustomerDetails.credit') });
      this.statmTransactions.cols.push({ dataField: 'vatAmountS', caption: this.$t('enquiriesCustomerDetails.vat') });
      this.statmTransactions.cols.push({ dataField: 'balanceS', caption: this.$t('enquiriesCustomerDetails.balance') });
      this.statmTransactions.cols.push({ dataField: 'currentReadingS', caption: this.$t('enquiriesCustomerDetails.reading') });
      this.statmTransactions.cols.push({ dataField: 'consumption', caption: this.$t('enquiriesCustomerDetails.consumption') });
      this.statmTransactions.cols.push({ dataField: 'statementNoAbs', caption: this.$t('enquiriesCustomerDetails.statementNo') });
      this.statmTransactions.cols.push({ dataField: 'billingDate', caption: this.$t('enquiriesCustomerDetails.statementDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.statmTransactions.cols.push({ dataField: 'propertyRef', caption: this.$t('enquiriesCustomerDetails.propertyRef') });
      this.statmTransactions.cols.push({ dataField: 'meterRef', caption: this.$t('enquiriesCustomerDetails.meterRef') });
      this.statmTransactions.cols.push({ dataField: 'glBatchNo', caption: this.$t('enquiriesCustomerDetails.batchNo') });
      this.statmTransactions.cols.push({ dataField: 'consumptionTypeS', caption: this.$t('enquiriesCustomerDetails.consumptionType') });
      this.statmTransactions.cols.push({ dataField: 'revTransNoAbs', caption: this.$t('enquiriesCustomerDetails.revTransNo') });
      this.statmTransactions.cols.push({ dataField: 'stampUser', caption: this.$t('enquiriesCustomerDetails.stampUser') });
      //this.statmTransactions.cols.push({ dataField: 'effectiveDate', caption: this.$t('enquiriesAccount.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      //this.statmTransactions.cols.push({ dataField: 'transactionType', caption: this.$t('enquiriesAccount.type') });
      //this.statmTransactions.cols.push({ dataField: 'transactionDescription', caption: this.$t('enquiriesAccount.description') });
      //this.statmTransactions.cols.push({ dataField: 'debit', caption: this.$t('enquiriesAccount.debit') });
      //this.statmTransactions.cols.push({ dataField: 'credit', caption: this.$t('enquiriesAccount.credit') });
      //this.statmTransactions.cols.push({ dataField: 'vatAmount', caption: this.$t('enquiriesAccount.vat') });


      //============
      //transactions

      this.transactions.cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });
      this.transactions.cols.push({ dataField: 'accountName', caption: this.$t('enquiriesAccount.accountName') });
      this.transactions.cols.push({ dataField: 'transNoAbs', caption: this.$t('enquiriesCustomerDetails.transNo') });
      this.transactions.cols.push({ dataField: 'transactionType', caption: this.$t('enquiriesCustomerDetails.type') });
      this.transactions.cols.push({ dataField: 'effectiveDate', caption: this.$t('enquiriesCustomerDetails.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.transactions.cols.push({ dataField: 'transactionDescription', caption: this.$t('enquiriesCustomerDetails.description') });
      this.transactions.cols.push({ dataField: 'documentNo', caption: this.$t('enquiriesCustomerDetails.documentRef') });
      this.transactions.cols.push({ dataField: 'debit', caption: this.$t('enquiriesCustomerDetails.debit') });
      this.transactions.cols.push({ dataField: 'credit', caption: this.$t('enquiriesCustomerDetails.credit') });
      this.transactions.cols.push({ dataField: 'vatAmountS', caption: this.$t('enquiriesCustomerDetails.vat') });
      this.transactions.cols.push({ dataField: 'balanceS', caption: this.$t('enquiriesCustomerDetails.balance') });
      this.transactions.cols.push({ dataField: 'currentReadingS', caption: this.$t('enquiriesCustomerDetails.reading') });
      this.transactions.cols.push({ dataField: 'consumption', caption: this.$t('enquiriesCustomerDetails.consumption') });
      this.transactions.cols.push({ dataField: 'statementNoAbs', caption: this.$t('enquiriesCustomerDetails.statementNo') });
      this.transactions.cols.push({ dataField: 'billingDate', caption: this.$t('enquiriesCustomerDetails.statementDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.transactions.cols.push({ dataField: 'propertyRef', caption: this.$t('enquiriesCustomerDetails.propertyRef') });
      this.transactions.cols.push({ dataField: 'meterRef', caption: this.$t('enquiriesCustomerDetails.meterRef') });
      this.transactions.cols.push({ dataField: 'glBatchNo', caption: this.$t('enquiriesCustomerDetails.batchNo') });
      this.transactions.cols.push({ dataField: 'consumptionTypeS', caption: this.$t('enquiriesCustomerDetails.consumptionType') });
      this.transactions.cols.push({ dataField: 'revTransNoAbs', caption: this.$t('enquiriesCustomerDetails.revTransNo') });
      this.transactions.cols.push({ dataField: 'stampUser', caption: this.$t('enquiriesCustomerDetails.stampUser') });
      this.transactions.cols.push({ dataField: 'stampDate', caption: this.$t('enquiriesCustomerDetails.stampDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
    },
    getData() {
      this.getStatements(true);
      this.getTransactions(true);
      this.getUnbilledTransaction(true);

      this.getCustomerDisplayInfo();
    },

    getStatements(loader = false) {
      this.statements.isLoading = loader;
      //console.log("cust", this.CustomerData)
      axios.get('/Enquiries2/GetStatements?account=' + this.custkey + '&page=' + this.statements.pageingOption.page + '&pageSize=' + this.statements.pageingOption.pageSize)
        .then(response => {
          if (response.status == 200) {
            //console.log("response", response)
            if (response.data.items && response.data.items.length > 0)
              response.data.items.forEach(i => {
                i['statementNoAbs'] = Math.abs(i.statementNo);
                i['invoiceNoAbs'] = Math.abs(i.invoiceNo);

                if (i.transactions && i.transactions.length > 0)
                  i.transactions.forEach(t => {
                    t['transactionIdAbs'] = Math.abs(t.transactionId);
                    t['statementIdAbs'] = Math.abs(t.statementId);
                  });
              });

            this.statements['data'] = response.data.items;
            this.statements['totalRow'] = response.data.itemsCount;

            this.lastInvoiveIssueDate = this.statements.data.length == 0 ? '' : moment(this.statements.data[0].statementDate).format('DD/MM/YYYY');
            this.lastInvoiveIssueAmount = this.statements.data.length == 0 ? '' : this.statements.data[0].balance.toString();
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => {
          this.statements.isLoading = false;
        });
    },
    getStatementTransactions(info) {
      if (info)
        this.selectedStatementId = info.rows[info.newRowIndex].data.statementNo;

      if (this.selectedStatementId == null)
        return;

      var parameters = {
        custkey: this.custkey,
        propertyId: this.propertyId,
        loginEmail: this.getLoginName(),
        Options: { pageSize: this.statmTransactions.pageingOption.pageSize, page: this.statmTransactions.pageingOption.page },
        StatementId: this.selectedStatementId,
      }
      //console.log("param", parameters);
      // console.log("state", info.rows[info.newRowIndex].data.statementId)
      axios.post('/Enquiries/getUnbilledTransaction', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.statmTransactions.data = response.data.items;

            this.statmTransactions.totalRow = response.data.itemsCount;

          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => {
          this.isTransactionsLoading = false;
        });
    },
    getUnbilledTransaction(loader = false) {
      this.unbilledTransactions.isLoading = loader;

      var parameters = {
        custkey: this.custkey,
        propertyId: this.propertyId,
        loginEmail: this.getLoginName(),
        Options: this.unbilledTransactions.pageingOption
      }

      axios.post('/Enquiries/getUnbilledTransaction', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.unbilledTransactions.data = response.data.items;
            this.unbilledTransactions.totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.unbilledTransactions.isLoading = false);
    },
    getTransactions(loader = false) {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.transactions.pageingOption
      }

      this.transactions.isLoading = loader;
      axios.post('/Enquiries/getCustomerTransactions', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.transactions.data = response.data.items;

            this.transactions.totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text), 4;
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.transactions.isLoading = false);
    },

    statementSelected(item) {

    },

    test(i) {
      console.log('szdsad',i)
    }
  },
}
